const lbaGroup = angular.module('app.lbaGroup', []);

lbaGroup.controller('lbaGroupCtrl', require('./lbaGroupCtrl'));
lbaGroup.directive('lbaGroup', require('./lbaGroupDir'));

export default lbaGroup;



// WEBPACK FOOTER //
// ./src/components/lbaGroup/index.js